<template>
<div class="mb-3">
    <div>
        <el-skeleton style="width: 100%; height: 80px;" animated v-if="inforatingIsEmpty">
            <template slot="template">
                <el-skeleton-item variant="rect" style="width: 100%; height: 80px;" />
            </template>
        </el-skeleton>
        <div v-else>
            <div class="d-flex align-items-center">
                <p class="ml-2 c-ndarkfour medium" v-if="!inforating.totalScore">Sem avaliações</p>
                <template v-else>
                    <h1 class="c-ndarkthree mb-0"> 
                    {{ inforating.average || '-' }}
                    </h1>
                    <p class="ml-2 c-ndarkfour medium">{{ inforating.totalScore }} avaliações</p>
                </template>
            </div>
            <star-rating inactive-color="#DFE2EB" :star-size="30" :rating="inforating.average" :read-only="true" :show-rating="false" :increment="0.01" class="mt-2" />
        </div>
    </div>
</div>
</template>

<script>
import StarRating from 'vue-star-rating'
import getRating from '@/api/getRating.js'
export default {
    props: {
        cnpjProvider: {
            type: String
        }
    },
    components: {
        StarRating
    },
    data() {
        return {
            inforating:{
                totalScore: 0,
                average: 5
            },
            inforatingIsEmpty: true,
        }
    },
    methods:{
    },
    async created() {
        const resul = await getRating(this.cnpjProvider)
        this.inforating = resul.payload;
        this.inforatingIsEmpty = false
    }
}
</script>

<style>
</style>
